import React, { forwardRef } from 'react';
import * as S from './style';

type InputProperties = React.InputHTMLAttributes<HTMLInputElement> & {
  error?: boolean;
};

const TextField = forwardRef<HTMLInputElement, InputProperties>(
  (properties, reference) => {
    return <S.Input {...properties} ref={reference} />;
  }
);

TextField.displayName = 'TextField';

export default TextField;
